import { ModalContentType } from "components/adhoc/gistreehierarchy";
import { HierarchyItemType } from "types/generic";

type ButtonStatus = "enabled" | "disabled";

export const defineModalTitle = (
    modalContentType: ModalContentType,
    translate: (id: string, defaultMessage?: string | undefined) => string,
    gisHierarchySelected: HierarchyItemType[]
) => {
    switch (modalContentType) {
        case "create-modal": {
            return translate("app.gis.hierarchy.create_new_group_or_layer");
        }
        case "edit-modal": {
            return translate("app.hierarchy.edit_group");
        }
        case "delete-modal": {
            if (
                gisHierarchySelected.length &&
                gisHierarchySelected[0].itemType
            ) {
                return translate("app.hierarchy.confirm_delete_layer_title");
            } else {
                return translate("app.hierarchy.confirm_delete_group_title");
            }
        }
        default: {
            return "";
        }
    }
};

export const buttonIsActive = (
    button: "add" | "edit" | "delete",
    gisHierarchySelected: HierarchyItemType[],
    modalContentType: ModalContentType
): ButtonStatus => {
    if (button === "add" || button === "edit") {
        if (!gisHierarchySelected.length) return "disabled";

        const allNodesAreLayers = gisHierarchySelected.every(
            (hierarchy) => hierarchy.itemType
        );

        if (allNodesAreLayers) return "disabled";
    } else {
        if (!gisHierarchySelected.length) return "disabled";
    }

    if (modalContentType !== "") return "disabled";

    return "enabled";
};
